"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[823],{

/***/ 33336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Tm": function() { return /* binding */ TARGET_DATE; },
  "ZP": function() { return /* binding */ Layouts_TopBanner; }
});

// UNUSED EXPORTS: DESCRIPTION

// EXTERNAL MODULE: ../../node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__(17160);
// EXTERNAL MODULE: ../../packages/pds-react/src/index.ts + 66 modules
var src = __webpack_require__(61810);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(36557);
;// CONCATENATED MODULE: ./components/Layouts/TopBanner/LineBanner/index.styles.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var LinkWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "egvbv9b0"
} : 0)( true ? {
  name: "1p3qk0r",
  styles: "&:hover{cursor:pointer;}"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./components/Layouts/TopBanner/LineBanner/index.tsx






var LineBanner = function LineBanner(_ref) {
  var link = _ref.link,
      description = _ref.description,
      isMobile = _ref.isMobile,
      isOpenNewTab = _ref.isOpenNewTab;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
    alignItems: "center",
    justifyContent: "center",
    gap: 16,
    backgroundColor: "skyblue_700",
    padding: {
      y: isMobile ? 16 : 8
    },
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
      variant: "sm-medium",
      color: "skyblue_100",
      children: description
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      children: isOpenNewTab ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
        href: link.url,
        target: "_blank",
        rel: "noopener noreferrer",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LinkWrapper, {
            gap: 4,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
              variant: "sm-semibold",
              color: "white",
              children: link.content
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
              icon: "ph:caret-right",
              size: 14,
              color: "white"
            })]
          })
        })
      }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: link.url,
        replace: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LinkWrapper, {
            gap: 4,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
              variant: "sm-semibold",
              color: "white",
              children: link.content
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
              icon: "ph:caret-right",
              size: 14,
              color: "white"
            })]
          })
        })
      })
    })]
  });
};

/* harmony default export */ var TopBanner_LineBanner = (LineBanner);
// EXTERNAL MODULE: ./components/Layouts/TopBanner/useCheckOverPeriod.ts
var useCheckOverPeriod = __webpack_require__(91378);
;// CONCATENATED MODULE: ./components/Layouts/TopBanner/index.tsx




var TARGET_DATE = '2023-11-12T23:59:59';
var DESCRIPTION = '파일을 열어보기 전 이메일을 입력받아보세요';

var TopBanner = function TopBanner() {
  var isMobile = (0,react_responsive.useMediaQuery)({
    maxWidth: 767
  });

  var _useCheckOverPeriod = (0,useCheckOverPeriod/* default */.Z)({
    targetDate: TARGET_DATE
  }),
      isValid = _useCheckOverPeriod.isValid;

  if (!isValid) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TopBanner_LineBanner, {
    description: DESCRIPTION,
    link: {
      content: '더 알아보기',
      url: 'https://salesclue.gitbook.io/guide/features/collect_email'
    },
    isMobile: isMobile,
    isOpenNewTab: true
  });
};

/* harmony default export */ var Layouts_TopBanner = (TopBanner);

/***/ }),

/***/ 91378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


var useCheckOverPeriod = function useCheckOverPeriod(_ref) {
  var targetDate = _ref.targetDate;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      isValid = _useState[0],
      setIsValid = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var currentTime = new Date();
    var targetTime = new Date(targetDate);
    setIsValid(currentTime < targetTime);
  }, []);
  return {
    isValid: isValid
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useCheckOverPeriod);

/***/ }),

/***/ 842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ User_Header; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(8529);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/jotai/esm/react.mjs
var react = __webpack_require__(752);
// EXTERNAL MODULE: ../../packages/pds-react/src/index.ts + 66 modules
var src = __webpack_require__(61810);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var node_modules_react = __webpack_require__(2784);
// EXTERNAL MODULE: ./state/user/atom.ts
var atom = __webpack_require__(37271);
// EXTERNAL MODULE: ./components/User/_components/common/ProPlanUpgradeModal/index.tsx + 22 modules
var ProPlanUpgradeModal = __webpack_require__(8898);
// EXTERNAL MODULE: ./components/Layouts/TopBanner/index.tsx + 2 modules
var TopBanner = __webpack_require__(33336);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(36557);
;// CONCATENATED MODULE: ./components/Layouts/User/Header/Logo/index.styles.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var Button = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "e8v86w0"
} : 0)( true ? {
  name: "2005ke",
  styles: "display:inline-flex;margin:8px"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./components/Layouts/User/Header/Logo/index.tsx






var Logo = function Logo() {
  var router = (0,next_router.useRouter)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button, {
    onClick: function onClick() {
      return router.push('/user/pdf');
    },
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
      src: "/images/salesclue_logo_white_alpha.png",
      width: 98,
      height: 23,
      priority: true
    })
  });
};

/* harmony default export */ var Header_Logo = (/*#__PURE__*/(0,node_modules_react.memo)(Logo));
// EXTERNAL MODULE: ./constants/zIndex.ts
var zIndex = __webpack_require__(90122);
;// CONCATENATED MODULE: ./components/Layouts/User/Header/index.styles.ts


function index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



var Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "e1oc1tvq3"
} : 0)("position:fixed;z-index:", zIndex/* Z_INDEX.layoutHeader */.k.layoutHeader, ";" + ( true ? "" : 0));
var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "e1oc1tvq2"
} : 0)("display:flex;width:100%;align-items:center;justify-content:space-between;padding:0 calc((100% - 1080px) / 2);border-bottom:1px solid ", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.zinc_200;
}, ";background-color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.white;
}, ";" + ( true ? "" : 0));
var NameContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1oc1tvq1"
} : 0)( true ? {
  name: "1yydxi7",
  styles: "display:flex;align-items:center;gap:8px"
} : 0);
var Left = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1oc1tvq0"
} : 0)( true ? {
  name: "1llzu2n",
  styles: "display:flex;align-items:center;gap:24px"
} : 0);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./hooks/queries/client/useInquirySummary.ts
var useInquirySummary = __webpack_require__(180);
;// CONCATENATED MODULE: ./components/Layouts/User/Header/Navigation/index.styles.ts


function Navigation_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var Ul = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "e140w8cl1"
} : 0)( true ? {
  name: "11jf4ye",
  styles: "display:flex;gap:8px"
} : 0);
var A = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "e140w8cl0"
} : 0)("display:flex;align-items:center;padding:16px 32px;color:", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.zinc_400;
}, ";cursor:pointer;gap:8px;transition:all 0.15s ease-in-out;&[data-state='active']{border-bottom:2px solid ", function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.skyblue_400;
}, ";background:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.skyblue_50;
}, ";color:", function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.skyblue_400;
}, ";}&:hover{background-color:", function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.zinc_200;
}, ";}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./components/Layouts/User/Header/Navigation/index.tsx







var NAVIGATION_NAMES = {
  Pdf: {
    name: 'PDF',
    route: '/user/pdf',
    className: 'pdf-menu'
  },
  Link: {
    name: '링크',
    route: '/user/link',
    className: 'link-menu'
  },
  Campaign: {
    name: '캠페인',
    route: '/user/campaign',
    className: 'campaign-menu'
  },
  Client: {
    name: '고객',
    route: '/user/client',
    className: 'client-menu'
  }
};

var Navigation = function Navigation() {
  var router = (0,next_router.useRouter)();

  var _useInquirySummary = (0,useInquirySummary/* default */.ZP)({
    staleTime: 30000,
    select: function select(data) {
      return data.data.data.unreadInquiryCount;
    }
  }),
      unreadInquiryCount = _useInquirySummary.data;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("nav", {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Ul, {
      children: Object.values(NAVIGATION_NAMES).map(function (_ref) {
        var name = _ref.name,
            route = _ref.route,
            className = _ref.className;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
          className: className,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
            href: route,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(A, {
              "data-state": router.pathname.includes(route) ? 'active' : 'inactive',
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
                variant: "lg-semibold",
                color: "inherit",
                children: name
              }), className === 'client-menu' && unreadInquiryCount != null && unreadInquiryCount > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Badge */.Ct, {
                backgroundColor: "vermillion_400",
                color: "white",
                paddingX: 6,
                paddingY: 2,
                title: "\uC0C8\uB85C\uC6B4 \uB9AC\uB4DC ".concat(unreadInquiryCount, "\uAC74"),
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
                  variant: "sm-semibold",
                  color: "inherit",
                  children: unreadInquiryCount > 99 ? '99+' : unreadInquiryCount
                })
              })]
            })
          })
        }, name);
      })
    })
  });
};

/* harmony default export */ var Header_Navigation = (Navigation);
;// CONCATENATED MODULE: ./components/Layouts/User/Header/index.tsx















var Header = function Header() {
  var _userInfo$subscriptio;

  var router = (0,next_router.useRouter)();
  var userInfo = (0,react/* useAtomValue */.Dv)(atom/* userInfoAtom */.w);
  var userPlanName = (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$subscriptio = userInfo.subscriptionPlan) === null || _userInfo$subscriptio === void 0 ? void 0 : _userInfo$subscriptio.name) || 'Free';

  var _React$useState = node_modules_react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      isOpen = _React$useState2[0],
      setIsOpen = _React$useState2[1];

  var isProPlus = (0,node_modules_react.useMemo)(function () {
    var _userInfo$subscriptio2;

    return (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$subscriptio2 = userInfo.subscriptionPlan) === null || _userInfo$subscriptio2 === void 0 ? void 0 : _userInfo$subscriptio2.name) === 'Pro Plus';
  }, [userInfo]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container, {
      direction: "column",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TopBanner/* default */.ZP, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Left, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header_Logo, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header_Navigation, {})]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
          gap: 8,
          width: "fit-content",
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
            variant: "viridian_300",
            paddingY: 8,
            paddingX: 16,
            leftIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
              icon: "ph:sparkle-fill",
              size: 19
            }),
            onClick: function onClick() {
              return router.push('/change-log');
            },
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
              children: "v1.39.0"
            })
          }), !isProPlus && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
            variant: "skyblue_400",
            leftIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
              icon: "ph:magic-wand-fill",
              size: 19
            }),
            onClick: function onClick() {
              setIsOpen(true);
            },
            children: "\uC5C5\uADF8\uB808\uC774\uB4DC"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
              variant: "zinc_200",
              leftIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
                icon: "ph:user-circle",
                size: 19
              }),
              paddingY: 9,
              paddingX: 16,
              color: "zinc_400",
              onClick: function onClick() {
                return router.push('/user/setting');
              },
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NameContainer, {
                children: [userInfo === null || userInfo === void 0 ? void 0 : userInfo.name, (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Badge */.Ct, {
                  radius: 4,
                  backgroundColor: userPlanName === 'Pro Plus' ? 'loyalblue_400' : userPlanName === 'Pro' ? 'skyblue_400' : userPlanName === 'Basic' ? 'viridian_400' : 'zinc_400' // Free 또는 null
                  ,
                  borderStyle: "none",
                  paddingX: 8,
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
                    variant: "sm-medium",
                    color: "white",
                    children: userPlanName === 'Pro Plus' ? 'Pro +' : userPlanName || 'Free'
                  })
                })]
              })
            })
          })]
        })]
      })]
    }), isOpen && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProPlanUpgradeModal/* default */.Z, {
      onOpenChange: function onOpenChange(open) {
        setIsOpen(open);
      }
    })]
  });
};

/* harmony default export */ var User_Header = (Header);

/***/ }),

/***/ 180:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "sm": function() { return /* binding */ INQUIRY_SUMMARY_QUERY_KEY; }
/* harmony export */ });
/* unused harmony export getInquirySummary */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7040);
/* harmony import */ var _utils_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74457);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var INQUIRY_SUMMARY_QUERY_KEY = ['getInquirySummary'];
var getInquirySummary = function getInquirySummary() {
  return _utils_api__WEBPACK_IMPORTED_MODULE_1__/* .api.get */ .h.get('/client/inquiry-summary');
};

var useInquirySummary = function useInquirySummary(options) {
  return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)(INQUIRY_SUMMARY_QUERY_KEY, getInquirySummary, _objectSpread({}, options));
};

/* harmony default export */ __webpack_exports__["ZP"] = (useInquirySummary);

/***/ }),

/***/ 73327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export getUserInfo */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7040);
/* harmony import */ var _utils_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74457);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var getUserInfo = function getUserInfo() {
  return _utils_api__WEBPACK_IMPORTED_MODULE_1__/* .api.get */ .h.get('/user');
};

var useUserInfo = function useUserInfo(options) {
  return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)(['getUserInfo'], getUserInfo, _objectSpread({
    enabled: false,
    retry: false
  }, options));
};

/* harmony default export */ __webpack_exports__["Z"] = (useUserInfo);

/***/ })

}]);